import React from 'react';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { toHalfWidth, trim, isNumber, PadZero} from '../modules/appLibrary';
import none from '../Resources/washmark/none.jpg';
import w100 from '../Resources/washmark/100.jpg';
import w110 from '../Resources/washmark/110.jpg';
import w111 from '../Resources/washmark/111.jpg';
import w130 from '../Resources/washmark/130.jpg';
import w131 from '../Resources/washmark/131.jpg';
import w132 from '../Resources/washmark/132.jpg';
import w140 from '../Resources/washmark/140.jpg';
import w141 from '../Resources/washmark/141.jpg';
import w142 from '../Resources/washmark/142.jpg';
import w150 from '../Resources/washmark/150.jpg';
import w151 from '../Resources/washmark/151.jpg';
import w200 from '../Resources/washmark/200.jpg';
import w210 from '../Resources/washmark/210.jpg';
import w220 from '../Resources/washmark/220.jpg';
import w300 from '../Resources/washmark/300.jpg';
import w310 from '../Resources/washmark/310.jpg';
import w320 from '../Resources/washmark/320.jpg';
import w410 from '../Resources/washmark/410.jpg';
import w415 from '../Resources/washmark/415.jpg';
import w420 from '../Resources/washmark/420.jpg';
import w425 from '../Resources/washmark/425.jpg';
import w430 from '../Resources/washmark/430.jpg';
import w435 from '../Resources/washmark/435.jpg';
import w440 from '../Resources/washmark/440.jpg';
import w445 from '../Resources/washmark/445.jpg';
import w500 from '../Resources/washmark/500.jpg';
import w510 from '../Resources/washmark/510.jpg';
import w511 from '../Resources/washmark/511.jpg';
import w520 from '../Resources/washmark/520.jpg';
import w530 from '../Resources/washmark/530.jpg';
import w600 from '../Resources/washmark/600.jpg';
import w610 from '../Resources/washmark/610.jpg';
import w611 from '../Resources/washmark/611.jpg';
import w620 from '../Resources/washmark/620.jpg';
import w621 from '../Resources/washmark/621.jpg';
import w700 from '../Resources/washmark/700.jpg';
import w710 from '../Resources/washmark/710.jpg';
import w711 from '../Resources/washmark/711.jpg';
import w712 from '../Resources/washmark/712.jpg';

//--------------------------------------------------------
//  洗濯マークRender
//
//  type:列番号
//  click: filedouwnload or fileDelete
//--------------------------------------------------------
export default function RenderWashMark(props) {
    const srcmap = [
        { src: w100, value: "100" },
        { src: w110, value: "110" },
        { src: w111, value: "111" },
        { src: w130, value: "130" },
        { src: w131, value: "131" },
        { src: w132, value: "132" },
        { src: w140, value: "140" },
        { src: w141, value: "141" },
        { src: w142, value: "142" },
        { src: w150, value: "150" },
        { src: w151, value: "151" },
        { src: w200, value: "200" },
        { src: w210, value: "210" },
        { src: w220, value: "220" },
        { src: w300, value: "300" },
        { src: w310, value: "310" },
        { src: w320, value: "320" },
        { src: w410, value: "410" },
        { src: w415, value: "415" },
        { src: w420, value: "420" },
        { src: w425, value: "425" },
        { src: w430, value: "430" },
        { src: w435, value: "435" },
        { src: w440, value: "440" },
        { src: w445, value: "445" },
        { src: w500, value: "500" },
        { src: w510, value: "510" },
        { src: w511, value: "511" },
        { src: w520, value: "520" },
        { src: w530, value: "530" },
        { src: w600, value: "600" },
        { src: w610, value: "610" },
        { src: w611, value: "611" },
        { src: w620, value: "620" },
        { src: w621, value: "621" },
        { src: w700, value: "700" },
        { src: w710, value: "710" },
        { src: w711, value: "711" },
        { src: w712, value: "712" },
    ]

    function cellValue() {
        if (props.value === "") return props.none;
        let Value = trim(toHalfWidth(props.value));
        if (props.type === 0) {
            if (props.washlist1.some(e=>e.value===Value)) {
                return Value;
            }
        }
        if (props.type === 1) {
            if (props.washlist2.some(e => e.value === Value)) {
                return Value;
            }
        }
        if (props.type === 2) {
            if (props.washlist3.some(e => e.value === Value)) {
                return Value;
            }
        }
        if (props.type === 3) {
            if (props.washlist4.some(e => e.value === Value)) {
                return Value;
            }
        }
        if (props.type === 4) {
            if (props.washlist5.some(e => e.value === Value)) {
                return Value;
            }
        }
        if (props.type === 5) {
            if (props.washlist6.some(e => e.value === Value)) {
                return Value;
            }
        }
        if (props.type === 6) {
            if (props.washlist7.some(e => e.value === Value)) {
                return Value;
            }
        }
        return props.none;
    }

    function ButtonClick(e) {
        props.clicked(props);
    }
    function imageSource() {
        let image = none;
        if (props.type === 0) {
            let target = props.washlist1.find(e => e.value === cellValue());
            if (target !== undefined) {
                let img = srcmap.find(e => e.value === target.key);
                if (img !== undefined) {
                    image = img.src;
                }
            }
        }
        if (props.type === 1) {
            let target = props.washlist2.find(e => e.value === cellValue());
            if (target !== undefined) {
                let img = srcmap.find(e => e.value === target.key);
                if (img !== undefined) {
                    image = img.src;
                }
            }
        }
        if (props.type === 2) {
            let target = props.washlist3.find(e => e.value === cellValue());
            if (target !== undefined) {
                let img = srcmap.find(e => e.value === target.key);
                if (img !== undefined) {
                    image = img.src;
                }
            }
        }
        if (props.type === 3) {
            let target = props.washlist4.find(e => e.value === cellValue());
            if (target !== undefined) {
                let img = srcmap.find(e => e.value === target.key);
                if (img !== undefined) {
                    image = img.src;
                }
            }
        }
        if (props.type === 4) {
            let target = props.washlist5.find(e => e.value === cellValue());
            if (target !== undefined) {
                let img = srcmap.find(e => e.value === target.key);
                if (img !== undefined) {
                    image = img.src;
                }
            }
        }
        if (props.type === 5) {
            let target = props.washlist6.find(e => e.value === cellValue());
            if (target !== undefined) {
                let img = srcmap.find(e => e.value === target.key);
                if (img !== undefined) {
                    image = img.src;
                }
            }
        }
        if (props.type === 6) {
            let target = props.washlist7.find(e => e.value === cellValue());
            if (target !== undefined) {
                let img = srcmap.find(e => e.value === target.key);
                if (img !== undefined) {
                    image = img.src;
                }
            }
        }
        return image;
    }
    function RenderBody() {
        if (props.type === 7) {
            return (
                <div style={{marginTop:30}} onClick={ButtonClick}>
                    <IconButton size="small">
                        <Icon>arrow_right</Icon>
                    </IconButton>
                </div>
            );
        }
        return (
            <div style={{ position: 'rerative' }}>
                {cellValue()}
                <div style={{ position: 'absolute', top: 30, left: 15 }}>
                    <img src={imageSource()} alt="" style={{ width:50 }} />
                </div>
            </div>
        );
    }
    return (
        <RenderBody />
    );
}
